import React from "react";
import { CalendarClock } from "lucide-react";

/**
 * PULA LEARN — launch countdown banner. Renders only while pre-launch AND a
 * launch date is configured (PULA_LEARN_LAUNCH_DATE env). Fill the date when
 * CPD gives a decision/launch date; leave blank to hide.
 */
export function LaunchCountdown({ launchDate, accredited }) {
  if (accredited || !launchDate) return null;
  const target = new Date(launchDate + "T09:00:00Z");
  if (isNaN(target.getTime())) return null;
  const days = Math.ceil((target.getTime() - Date.now()) / 86400000);
  const nice = target.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  return (
    <div className="mv-green-bg border-b border-white/10" data-testid="launch-countdown-banner">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-3 flex items-center justify-center gap-2 text-white text-sm text-center">
        <CalendarClock size={16} className="mv-gold-text shrink-0" />
        <span>
          Accredited enrolment opens <strong>{nice}</strong>
          {days > 0 ? ` — ${days} day${days === 1 ? "" : "s"} to go` : days === 0 ? " — today" : ""}
        </span>
      </div>
    </div>
  );
}
